import { useEffect, useRef } from 'react';

import { Spin } from 'antd';
import { History } from 'history';
import { match } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../store';
import { fetchStoreBuild } from '../../../store/features/storeBuilds/storeBuildsSlice';
import StoreBuilder from './components/StoreBuilder';

import './StoreBuilderDetailsView.less';
interface StoreBuilderDetailsViewProps {
  match: match<any>;
  history: History;
}

const StoreBuilderDetailsView = ({
  history,
  match,
}: StoreBuilderDetailsViewProps) => {
  const { id } = match.params;
  // const [fetchingStoreBuild, build, { updateStoreBuild }] = useStoreBuild(id);

  const dispatch = useAppDispatch();

  const { fetchingStoreBuild, currentStoreBuild } = useAppSelector(
    (state) => state.storeBuilds
  );

  const requestedBuildIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!id) return;

    // Avoid duplicate fetches under StrictMode and re-renders
    if (requestedBuildIdRef.current === id) return;

    // Always fetch fresh data when entering the details view to ensure we have the latest saved data
    // This is especially important after saving, as the build data may have changed
    requestedBuildIdRef.current = id;
    dispatch(fetchStoreBuild({ storeBuildId: id }))
      .unwrap()
      .catch(() => {
        // Allow retry on failure
        requestedBuildIdRef.current = null;
      });
  }, [dispatch, id]);

  if (fetchingStoreBuild) {
    return (
      <div className="spin-wrapper">
        <Spin />
      </div>
    );
  }

  return currentStoreBuild !== null ? (
    <StoreBuilder history={history} build={currentStoreBuild!} />
  ) : (
    <div>No data available for this store build</div>
  );
};

export default StoreBuilderDetailsView;
